import { render, staticRenderFns } from "./channelFilterRuleType.vue?vue&type=template&id=129e4e60"
import script from "./channelFilterRuleType.vue?vue&type=script&lang=js"
export * from "./channelFilterRuleType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports